import Lista from './Lista';

export const AvaliacaoDesempenhoLista = Lista;

export default AvaliacaoDesempenhoLista;
